import { createFileRoute } from '@tanstack/react-router';

/**
 * Aba Funil (board) do módulo Pipeline — conteúdo idêntico ao antigo /pipeline (Kanban/tabela +
 * toolbar, DEC-030/DEC-031). Componente vem de pipeline.index.lazy.tsx (code-splitting por rota,
 * D4/DEC-060).
 */
export const Route = createFileRoute('/pipeline/')({});
